// Virgülle ayrılmış tek bir metin alanında birden fazla değer tutmak için yardımcılar.
export const parseCommaList = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) {
        return value.map(item => String(item).trim()).filter(Boolean);
    }
    if (typeof value !== 'string') return [];
    return value.split(',').map(item => item.trim()).filter(Boolean);
};

export const sanitizeList = (list) => {
    return (list || []).map(item => item.trim()).filter(Boolean);
};
